import { environment } from '../../../environments/environment';

export var apiBaseUrls = environment.apiBaseUrls;
export var ImageBaseUrls = environment.ImageBaseUrls;